//#region src/extensions/link-extension/utils/update-link-colors.ts
var e = (e, t) => {
	let { state: n } = e, r = n.tr, i = !1;
	n.doc.descendants((e, n) => {
		let a = n + e.nodeSize;
		e.marks.forEach((e) => {
			if (e.type.name === "link") {
				let o = e.type.create({
					...e.attrs,
					color: t
				});
				r.removeMark(n, a, e.type).addMark(n, a, o), i = !0;
			}
		});
	}), i && e.view.dispatch(r);
};
//#endregion
export { e as updateLinkColors };
